import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const Footer = styled(Box)(() => ({
    height: "75px",
    textAlign: 'center',
    fontSize: '0.9em',
    '> a': {
        width: "75px",
        height: "50px",
        display: "block",
        margin: "0 auto",
        backgroundImage: 'url("/carel-logo.png")',
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "75px 40px"
    }
}))
